import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";

@Injectable()
export class NavigationService {
  private history: string[] = [];
  public count: number = 0;

  constructor(private router: Router, private location: Location) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
        this.count = this.history.length;
      }
    });
  }

  back(): void {
    this.history.pop();
    this.count = this.history.length;
    if (this.count > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
  }
}
